import { defineMessages, type MessageDescriptor } from 'react-intl';

export const i18n: Record<'tag' | 'placeholder' | 'selected' | 'suggested', MessageDescriptor> =
	defineMessages({
		tag: {
			id: 'search-page.search-page-relay.filters.product-filters.tag.tag',
			defaultMessage: 'Tag',
			description: 'Label for filtering Loom search results by tag.',
		},
		placeholder: {
			id: 'search-page.search-page-relay.filters.product-filters.tag.placeholder',
			defaultMessage: 'Find tags',
			description: 'Placeholder for the Loom tag filter search input.',
		},
		selected: {
			id: 'search-page.search-page-relay.filters.product-filters.tag.selected',
			defaultMessage: 'Selected',
			description: 'Group heading for selected Loom tags.',
		},
		suggested: {
			id: 'search-page.search-page-relay.filters.product-filters.tag.suggested',
			defaultMessage: 'Suggested',
			description: 'Group heading for suggested Loom tags.',
		},
	});
